import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <h1 className="page-title">Case Study</h1>
          <p className="page-description">
            Transforming Sustainability Challenges into Success Stories
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
